import React from 'react';
import Window from "../components/Window";
import Form from "../components/Form";
import Input from "../components/Input";
import styled from "styled-components";
import Card from "../components/Card";
import Button from "../components/Button";
import * as api from '../lib/api';
import { useState, useEffect, useRef } from 'react';
import { NotificationManager } from "react-notifications";
import { connect } from 'react-redux';
import { useHistory } from "react-router-dom";
import * as validation from "../lib/validation";
import * as actions from '../state/actions';
import CanAccessDashboard from '../security/rules/CanAccessDashboard';



const ResetPasswordScreen = (props) => {
  let user = props.location.state.user;
  const token = props.location.state.token;

  const history = useHistory();
  const firstUpdate = useRef(true);
  const [state, setState] = useState({
    newPassword: '',
    confirmPassword: ''
  });

  const [errors, setErrors] = useState({
    newPassword: '',
    confirmPassword: '',
    passwordMatch: true
  });

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }

    setErrors(validate(state));

  }, [state]);

  function handleChange(e) {
    const { id, value } = e.target
    setState(prevState => ({
      ...prevState,
      [id]: value
    }));
  }

  function login(token, user) {
    const { dispatch } = props;

    dispatch(actions.signIn(token, user));
    history.push('/');
  }

  async function handleChangePassword() {
    setErrors(validate(state));

    try {

      if (errors.newPassword !== null || errors.confirmPassword !== null) {
        return;
      }

      if (!errors.passwordMatch) {
        NotificationManager.error('Password confirmation does not match password.');
        return;
      }

      if (!CanAccessDashboard(user)) {
        throw new Error('Insufficient permissions');
      }
  
      // set the new password and update the user info
      user.password = state.newPassword;
      await api.updateUser(user, token);

      NotificationManager.success(`Your password has been successfully reset!`);
      login(token, user);
    }
    catch (e) {
      NotificationManager.error('Unable to submit your request. Please try again');
    }
  }

  return (
    <Window title="Reset Password">
      <Content>
        <ResetPasswordContainer>
          <H1>Reset Password</H1>
          <ResetPasswordForm onSubmit={handleChangePassword}>
            <Form.Group>
              <Input
                id="newPassword"
                label="New Password"
                type="password"
                required
                autoComplete="new-password"
                invalid={errors.newPassword}
                validationText={errors.newPassword}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group>
              <Input
                id="confirmPassword"
                label="Confirm Password"
                type="password"
                required={true}
                autoComplete="confirm-password"
                invalid={errors.confirmPassword}
                validationText={errors.confirmPassword}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group>
              <Options>
                <Button type="submit">Submit</Button>
                <Button secondary to={'/'}>Cancel</Button>
              </Options>

            </Form.Group>

          </ResetPasswordForm>
        </ResetPasswordContainer>
      </Content>
    </Window>
  );
}

const isValuePresent = validation.create((value, { isEmpty, trim }) => !isEmpty(trim(value)));

function validate(state) {
  return {
    newPassword: isValuePresent(state.newPassword) ? null : 'A password is required',
    confirmPassword: isValuePresent(state.newPassword) ? null : 'Confirm password is required',
    passwordMatch: state.newPassword === state.confirmPassword ? true : false
  };
}


const Options = styled.div`
  margin-top: 2rem;
  text-align: right;
  
  ${Button} {
    margin-left: 1rem;
  }
`;

const ResetPasswordContainer = styled(props => <Card borderTop {...props} />)`
  flex: 1;
  max-width: 28rem;
  margin: 0 1.25rem;
`;

const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

const ResetPasswordForm = styled(Form)`
  margin: 0;
  padding: 1.875rem;
`;

const H1 = styled.h1`
  font-weight: 300;
  margin: 0;
  margin-top: 1.875rem;
  text-align: center;
  font-size: 2rem;

  @media (max-width: 400px) {
    font-size: 1.5rem;
  }
`;


export default connect()(ResetPasswordScreen);
